import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  constructor(
    public router: Router,
    public authService: AuthService
  ) {
    if (this.authService.userData) {
      let token = this.authService.userData.token;

      if (token) {
        this.router.navigate([`/vin-information`]);
      }
    }
  }

  ngOnInit(): void {
    const carousel = document.getElementById('carouselExample');
    carousel &&
      carousel.addEventListener('slid.bs.carousel', (event) => {
        const carouselEvent = event as unknown as { to: number };
        const totalSlides = carousel.querySelectorAll('.carousel-item').length;
        const prevBtn = carousel.querySelector('.carousel-control-prev') as HTMLButtonElement;
        const nextBtn = carousel.querySelector('.carousel-control-next') as HTMLButtonElement;
        const lastSlide = totalSlides - 1;

        if (lastSlide === carouselEvent.to) {
          nextBtn.disabled = true;
        } else if (carouselEvent.to === 0) {
          prevBtn.disabled = true;
        } else {
          nextBtn.disabled = false;
          prevBtn.disabled = false;
        }
      });
  }
}
